export enum ViewTypeEnum {
  ProductList = 0,
  ProductDetails = 1,
  StoreDetails= 2,
  ShoppingCart = 3,
  Checkout= 4,
}
